import { Col, Form, message, Modal, notification, Row, Spin } from 'antd';
import queryString from 'query-string';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

import ZenFormInput from './InputCreater/ZenFormInput';
import { createRoute } from '../utils/CustomFunc';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import liracrypt from '../components/Liracrypt/liracrypt';
import ZenModal from '../components/ZenModal';
import noImg from '../assets/static/noImg.jpeg';
import Scanter from '../components/STORM/Scanter';
import FooterButtons from '../components/STORM/FooterButtons';
import dayjs from 'dayjs';

const initialState = {
    mainData: null
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'setMainData':
            return { ...state, mainData: action.payload };
        default:
            return state;
    }
};

const DynamicScanter = ({
    setPageHeader,
    urlData,
    api = '/ds'
}) => {
    const [selectedButton, setSelectedButton] = useState();
    const [zenModal, setZenModal] = useState();
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
        setModal({ show, data, type, loading });
    }
    const { search } = useLocation();
    const urlCode = useSelector(state => state.urlCode);
    const searchParams = queryString.parse(search);
    const [pageData, dispatch] = useReducer(reducer, initialState);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];
    const LocalDict = [];
    const [form] = Form.useForm();

    const getData = () => {
        liracrypt.get(api, { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    console.log(data.data);
                    setPageHeader(data.config?.pageTitle);
                    dispatch({ type: "setMainData", payload: data.data });
                    setLoading(false);
                } else {
                    notification.error({ message: data.message || 'Something went wrong!', placement: 'top' });
                }
            }).catch(err => {
                console.error(err);
                ApiErrorComp();
            })
    }
    useEffect(() => {
        setLoading(true);
        getData();
    }, [search]);

    const queryElements = (controls) => {
        return (
            <Row justify={"space-between"} style={{ alignItems: 'center' }}>
                {
                    controls.map((data, index) => {
                        if (dtArray.includes(data["typ"])) {

                            LocalDict[data["data_index"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                            LocalDict["data_index_from"] = data["data_index_from"];
                            LocalDict["data_index_to"] = data["data_index_to"];
                        }

                        if (data.visible) {
                            return (
                                <React.Fragment key={index}>
                                    <ZenFormInput
                                        //    urlData={{ ...urlData }}
                                        childType={data.childType}
                                        pageType={"zenForm"}
                                        header={data.header}
                                        footer={data.footer}
                                        labelColSpan={data["labelColSpan"]}
                                        style={data['style']}
                                        height={data['height']}
                                        layoutPosition="space-between"
                                        form={form}
                                        LocalDict={LocalDict}
                                        rows={data.rows}
                                        colSpan={data.colSize || 12}
                                        name={data["data_index"]}
                                        label={data["label"]}
                                        defaultValue={data["default"]}
                                        typ={data["typ"]}
                                        disabled={data["readOnly"]}
                                        source={data["source"]}
                                        sourceParams={data["sourceParams"]}
                                        auxParams={data["auxParams"]}
                                        format={data["format"]}
                                        errorMessage={data["errorMessage"]}
                                        placeHolder={data["placeHolder"]}
                                        required={data["required"]}
                                        options={data["data"]}
                                        from={data["data_index_from"]}
                                        to={data["data_index_to"]}
                                        url={data["url"]}
                                        includeAll={data["includeAll"]}
                                        pname={data["p_data_index"]}
                                        defaultFrom={data["defaultFrom"]}
                                        defaultTo={data["defaultTo"]}
                                        multiSelect={data["multiSelect"]}
                                        searchable={data["isSearchable"]}
                                        data={data}
                                        //   extraData={extraData}
                                        children={data['children']}
                                    />
                                </React.Fragment>
                            );
                        }
                    })}
            </Row>)
    }

    const onResponse = ({ button, barCode, values }) => {
        if (button.buttonProp?.smodal) {
            return openSmodal(button);
        }
        if (!button?.buttonProp?.postSubmitAction) return;
        onColumnClick({ record: { ...values }, zenPop: button?.postSubmitActionProp[barCode] || button?.postSubmitActionProp });
    };

    const openSmodal = (btnData) => {
        setZenModal(btnData.smodalProp);
        let urlData = { ...searchParams, ...btnData?.smodalProp?.params, ...form.getFieldsValue() };
        // if (btnData.smodalProp?.multiProps?.length) {
        //     btnData.smodalProp?.multiProps.forEach(x => {
        //         urlData[x] = form.getFieldValue(x);
        //     })
        // }
        return toggleModal({
            show: true,
            data: {
                urlData: { ...urlData }
            },
            type: 'smodal',
            loading: false
        });
    }

    const zenPopupAction = (zenPopup, value, record) => {
        let _urlData = { ...searchParams, ...urlData, ...zenPopup.params };
        if (zenPopup?.props) {
            _urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                _urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData: _urlData,
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData: _urlData,
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, _urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
        if (zenPopup?.typ === 'scanter') {
            return toggleModal({
                show: true,
                data: {
                    scanter: zenPopup?.scanter,
                    urlData: _urlData,
                },
                loading: false,
                type: zenPopup?.typ
            })
        }
        return toggleModal({
            show: true,
            data: {
                urlData: { ...zenPopup?.submitData?.params },
                api: zenPopup?.submitData?.api,
                method: zenPopup?.submitData?.method,

            },
            loading: false,
            type: zenPopup?.typ
        })
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    notification.success({ message: response.data.message || 'Successfull', placement: 'top' });
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    notification.success({ message: response.data.message || 'Successfull', placement: 'top' });
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    notification.success({ message: response.data.message || 'Successfull', placement: 'top' });
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = ({ record, zenPop }) => {
        if (zenPop) {
            let zenPopDataIndex = { ...zenPop };
            if (zenPopDataIndex?.typ === "refreshPage") {
                if (zenPopDataIndex.delay) {
                    return setTimeout(() => scanterPostSubmitAction(zenPopDataIndex), zenPopDataIndex.delay);
                } else {
                    return scanterPostSubmitAction(zenPopDataIndex);
                }
            }
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...urlData, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...urlData, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    const onScanterFinish = ({ button, barCode }) => {

        let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params, ...form.getFieldsValue() };
        postData.barCode = barCode;
        if (button?.submitFormDataProp?.method === 'POST') {
            liracrypt.post(button?.submitFormDataProp.api, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message, placement: 'top' });
                    onResponse({ button, response, barCode })
                } else {
                    notification.error({ message: response.data.message, placement: 'top' })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong', placement: 'top'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            liracrypt.patch(button?.submitFormDataProp.api, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message, placement: 'top' });
                    onResponse({ button, response, barCode })
                } else {
                    notification.error({ message: response.data.message, placement: 'top' })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong', placement: 'top'
                    })
                })
        };
    }

    const scanterPostSubmitAction = (postSubmitAction) => {
        toggleModal({ show: false, data: undefined, type: "", loading: false });
        setZenModal(undefined);
        if (postSubmitAction.typ === 'refreshPage') {
            form.resetFields();
            setLoading(true);
            getData();
        }
    }

    const scanterCallback = () => {
        let postSubmitAction = zenModal?.scanter?.buttonProp?.postSubmitAction ? zenModal?.scanter?.postSubmitActionProp : null;
        if (postSubmitAction.delay) {
            setTimeout(() => scanterPostSubmitAction(postSubmitAction), postSubmitAction.delay);
        } else {
            scanterPostSubmitAction(postSubmitAction);
        }

    }


    const onFinish = async (value) => {
        let data = { ...searchParams, ...urlData, ...value };
        Object.keys(data).forEach((key) => {
            if (data[key]) {
                if (Array.isArray(data[key]) && LocalDict[key]) {
                    data[
                        LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
                    ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
                    data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
                        dayjs(data[key][1]).format(LocalDict[key]).toString();
                    delete data[key];
                } else {
                    if (LocalDict[key]) {

                        data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
                    }
                }
            }
        });
        let formData = new FormData();
        let submitFormDataProp = selectedButton?.submitFormDataProp;
        let { method, api, params } = submitFormDataProp;
        data = { ...params, ...data };
        Object.keys(data).forEach(x => {
            let val = data[x];
            if (val !== undefined && val !== null) {
                if (typeof val === 'object') {
                    if (!(val instanceof File)) {
                        val = JSON.stringify(val);
                    }
                }
                formData.append(x, val);
            }
        });
        try {
            let response;
            if (method === 'POST') {
                if (submitFormDataProp?.dataType === 'formData') {
                    response = await liracrypt.uploadFile(api, formData);
                } else {
                    response = await liracrypt.post(api, data);
                }
            }
            if (method === 'PATCH') {
                if (submitFormDataProp?.dataType === 'formData') {
                    response = await liracrypt.fileUploadPatch(api, formData);
                } else {
                    response = await liracrypt.patch(api, data);
                }
            }
            if (method === 'DELETE') {
                response = await liracrypt.delete(api, data);
            }
            if (response.data.isSuccess) {
                notification.success({ message: response.data.message || 'Successfull', placement: 'top' });
                onResponse({ button: selectedButton, response, barCode: data.barCode });
            }
        } catch (err) {
            ApiErrorComp();
        }

    }

    return (
        <div className='' style={{ padding: 10 }}>
            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} scanterCallback={scanterCallback} smodalCallback={() => {
                setLoading(true);
                getData();
            }} />
            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <LoadingOutlined
                            style={{ fontSize: 80, color: "#007bff" }}
                            spin
                        />
                    </div> :
                    <Row>
                        {
                            pageData?.mainData?.length &&
                            pageData?.mainData?.map((x, i) => (
                                <Col span={x.colSize} style={{ ...x.containerStyle }}>
                                    {
                                        x.scanter ?
                                            <Scanter
                                                disableScanter={modal?.show}
                                                onFinish={onScanterFinish}
                                                postSubmitAction={onResponse}
                                                openPopupModal={() => { }}
                                                button={x.scanter}
                                                // setSelectedButton={setSelectedButton}
                                                form={null}
                                                label={x.scanter?.buttonProp?.label}
                                                type={x.scanter?.buttonProp?.type}
                                                disabled={!x.scanter?.buttonProp?.enable}
                                                confirmationPopUp={x.scanter?.buttonProp?.confirmationPopUp ? x.scanter?.confirmationPopUpProp : undefined}
                                                submitFormData={x.scanter?.submitFormDataProp}
                                            />
                                            :
                                            <div
                                                className="AuditSection CreateAudit">
                                                <div className="ThemeForm">
                                                    <Form
                                                        labelWrap={true}
                                                        name={"ReportForm"}
                                                        form={form}
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        layout="horizontal"
                                                        colon={false}
                                                        onFinish={onFinish}
                                                        size="large"
                                                    >
                                                        {queryElements(x.elements)}
                                                        <>
                                                            {
                                                                x.bat &&
                                                                <div
                                                                    style={{
                                                                        marginTop: "10px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    {Object.keys(x.bat).map((btn, idx) => {
                                                                        const button = x.bat[btn];
                                                                        if (button?.buttonProp?.visible) {
                                                                            return (
                                                                                <React.Fragment key={idx}>
                                                                                    <FooterButtons
                                                                                        postSubmitAction={onResponse}
                                                                                        openPopupModal={() => { }}
                                                                                        button={button}
                                                                                        setSelectedButton={setSelectedButton}
                                                                                        openSmodal={openSmodal}
                                                                                        form={form}
                                                                                        label={button?.buttonProp?.label}
                                                                                        type={button?.buttonProp?.type}
                                                                                        disabled={!button?.buttonProp?.enable}
                                                                                        confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                                                        submitFormData={button?.submitFormDataProp}
                                                                                    />
                                                                                </React.Fragment>

                                                                            )
                                                                        }
                                                                    })}
                                                                </div>

                                                            }
                                                        </>
                                                    </Form>
                                                </div>
                                            </div>
                                    }
                                </Col>
                            ))
                        }
                    </Row>

            }
        </div>
    )
};

export default DynamicScanter;